import createCachedSelector from 're-reselect';
import {getParkingLotsByBuildingId} from '../parkingLot/selectors';
import {RootState} from '../../rootReducer';
import {isDayClosed} from '../openingDays/helpers';
import {DayName} from '..';
import {format} from 'date-fns';

export const getAreAllParkingNodesClosed = createCachedSelector(
  (state: RootState, date: Date, buildingId: string) => getParkingLotsByBuildingId(state, buildingId),
  (_state: RootState, date) => date,
  (parkingLots, date) => {
    if (!parkingLots.length) return false;
    const formattedDate = format(date, 'EEEE') as DayName;

    return Object.values(parkingLots).every((parkingLot) => {
      if (!parkingLot || !date) {
        return false;
      }

      return isDayClosed(formattedDate, parkingLot.openingDays);
    });
  },
)((_, date, buildingId) => `${date?.toISOString() || ''}-${buildingId}`);
